<table class="table">
	<thead>
		<tr>
			<th>&nbsp;</th>
			<th>&nbsp;</th>
			<th>
				{{agent.appRole?.name}}
			</th>
		</tr>
	</thead>
	<tbody>
		<tr class="table-dark">
			<td>Agent Management</td>
			<td [colSpan]="2">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of agentPermissions; trackBy: trackByHash">
			<td>{{permission.permission}}</td>
			<td>{{permission.description}}</td>
			<td class="text-center"><input type="checkbox" style="transform: scale(1.5);" [checked]="permission.selected"  (click)="$event.preventDefault()" [disabled]="true"/></td>
		</tr>

		<tr class="table-dark">
			<td>Partner Management</td>
			<td [colSpan]="2">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of partnerPermissions; trackBy: trackByHash">
			<td>{{permission.permission}}</td>
			<td>{{permission.description}}</td>
			<td class="text-center"><input type="checkbox" style="transform: scale(1.5);" [checked]="permission.selected"  (click)="$event.preventDefault()" [disabled]="true"/></td>
		</tr>

		<tr class="table-dark">
			<td>Subscriber File Upload</td>
			<td [colSpan]="2">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of importPermissions; trackBy: trackByHash">
			<td>{{permission.permission}}</td>
			<td>{{permission.description}}</td>
			<td class="text-center"><input type="checkbox" style="transform: scale(1.5);" [checked]="permission.selected"  (click)="$event.preventDefault()" [disabled]="true"/></td>
		</tr>

		<tr class="table-dark">
			<td>Subscriber</td>
			<td [colSpan]="2">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of subscriberPermissions; trackBy: trackByHash">
			<td>{{permission.permission}}</td>
			<td>{{permission.description}}</td>
			<td class="text-center"><input type="checkbox" style="transform: scale(1.5);" [checked]="permission.selected"  (click)="$event.preventDefault()" [disabled]="true"/></td>
		</tr>


		<tr class="table-dark">
			<td>Masking</td>
			<td [colSpan]="2">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of maskingPermissions; trackBy: trackByHash">
			<td>{{permission.permission}}</td>
			<td>{{permission.description}}</td>
			<td class="text-center"><input type="checkbox" style="transform: scale(1.5);" [checked]="permission.selected"  (click)="$event.preventDefault()" [disabled]="true"/></td>
		</tr>


		<tr class="table-dark">
			<td>System</td>
			<td [colSpan]="2">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of systemPermissions; trackBy: trackByHash">
			<td>{{permission.permission}}</td>
			<td>{{permission.description}}</td>
			<td class="text-center"><input type="checkbox" style="transform: scale(1.5);" [checked]="permission.selected"  (click)="$event.preventDefault()" [disabled]="true"/></td>
		</tr>
	</tbody>
</table>
